<template>
  <div class="table-responsive-md minh">
    <table
      class="table table-hover"
      :class="{ 'isSearching': isSearching }"
      v-if="data">
      <thead>
        <tr>
          <th v-if="selectable" scope="col"></th>
          <th scope="col" class="w-10">Brand</th>
          <th scope="col" class="w-10">Opp. Owner</th>
          <th scope="col" class="w-10">Ref. Number</th>
          <th scope="col" class="w-20">Opp. Name</th>

          <th scope="col " class="w-10">Travel date</th>
          <th scope="col" class="wd150">Stage</th>
          <th scope="col " class="w-10">Last Modified</th>

          <th v-if="showEdit" scope="col">&nbsp;</th>
          <th v-if="showDuplicate" scope="col">Duplicate</th>
          <th v-if="showDelete" scope="col"></th>
        </tr>
      </thead>
      <tbody v-if="!(Array.isArray(data) && data.length)">
        <OpportunityListNotFound />
      </tbody>
      <tbody v-if="data">
        <OpportunityListRow
          :ref="`row_${opportunity.uuid}`"
          v-for="opportunity in data"
          :key="opportunity.uuid"
          :data="opportunity"
          :meta="meta"
          :isDeleting="opportunity && selectedRow && opportunity.uuid === selectedRow.opportunity.uuid"
          :isDuplicating="isDuplicating"
          :isSearching="isSearching"
          :selectedRow="selectedRow"
          :selectable="selectable"
          :show-delete="showDelete"
          :on-select="onSelect"
          :show-duplicate="showDuplicate"
          :show-edit="showEdit"
          @onDuplicate="onDuplicate(opportunity, meta)"
          @onDelete="onDelete(opportunity, meta)" />
      </tbody>
    </table>

    <Modal :isSizeExtraLarge="isSizeExtraLarge" :show="isModalShow" @close="onCloseModal2">
      <div class="text-left mb-4" v-if="currentModal === 'duplicate'">
        <p class="lead">Create a new version for:</p>
        <table class="table mb-3" v-if="selectedRow && selectedRow.opportunity">
          <thead>
            <tr>
              <th scope="col" class="w-10">Brand</th>
              <th scope="col" class="w-10">Opp. Owner</th>
              <th scope="col" class="w-10">Ref. Number</th>
              <th scope="col" class="w-20">Opp. Name</th>
              <th scope="col" class="w-10">Travel date</th>
              <th scope="col" class="wd150">Stage</th>
              <th scope="col" class="w-10">Last Modified</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-light">
              <td class="align-middle text-center">
                <span
                  class="kt-badge kt-badge--brand kt-badge--lg badge-acronym"
                  :class="`badge-acronym--${selectedRow.opportunity.acronym_brand.toLowerCase()}`">{{ selectedRow.opportunity.acronym_brand }}</span>
              </td>
              <td class="align-middle">
                {{ selectedRow.opportunity.firstname }} {{ selectedRow.opportunity.lastname }}
              </td>
              <td class="align-middle text-break reference_number_table">{{ selectedRow.opportunity.reference_number }}</td>
              <td class="align-middle text-break">
                {{ selectedRow.opportunity.opportunity_name || 'Untitled' }}
              </td>
              <td class="align-middle">
                {{ selectedRow.opportunity.departure_date | custom-date('MMMM d, yyyy') }}
              </td>
              <td nowrap class="align-middle">
                <div style="display: inline-block; width: 100%">
                  <div style="display: flex; flex-direction: column">
                    <span
                      class="badge badge-light text-capitalize stage-supplier-label"
                      :style="styleStageSupplier(selectedRow.opportunity.id_stage_supplier)"
                      v-if="selectedRow.opportunity && selectedRow.opportunity.stage_supplier_label">
                      {{ selectedRow.opportunity.stage_supplier_label }}
                    </span>
                  </div>
                </div>
                  <svg class="iconSignatureList" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 554 385" style="enable-background:new 0 0 554 385;" xml:space="preserve">
                    <path class="st0" d="M262.6,317.1c2.9-3.8,5.8-7.5,8.8-11.3c7.4-9.3,15.1-18.2,26.9-22.3c12.5-4.4,25.1,3.7,25.6,16.9
                    c0.2,5.5-0.5,11-0.8,16.4c-0.1,2.1-0.3,4.2-0.5,7c11.7-3.6,21.3-9.3,30.1-16.5c8.9-7.2,14.9-16.4,19-27c2.9-7.5,9.9-11.6,17.8-11.2
                    c8.1,0.4,14.3,4.3,16.7,12c1.3,4.3,1.4,9.8-0.1,14c-9.4,27.3-29.2,45.2-54.4,57.6c-8,3.9-16.6,7-25.2,9.1
                    c-13.8,3.4-27.5,3.5-39.8-14.5c-10.1,10.1-21.7,16.7-36.5,13.4c-15.2-3.3-22.4-14.3-26.3-29.2c-2.2,1.8-4,3.2-5.7,4.7
                    c-16.1,14-32.3,27.9-52.1,36.5c-15.6,6.8-31.4,8.8-47.3,0.9c-8.9-4.4-15.7-11.2-20.7-19.7c-2-3.4-3.8-3.5-7.2-1.9
                    C73,360.5,55.2,369,37,376.8c-11,4.7-21.6-0.2-25.5-10.4c-3.9-10.3,1.1-19.9,12.1-24.9c18.5-8.4,36.7-17.3,55.1-25.8
                    c3.9-1.8,4.9-4.3,4.8-8.6c-1-33.5,5.3-65.3,22.7-94.3c8.9-14.9,21-26.6,38.5-30.4c7.6-1.7,16-1.6,23.7-0.2
                    c10,1.8,15.3,10.2,19.4,18.7c8.4,17.3,6,34.8-0.7,51.8c-11.3,28.7-30,52-53.2,72c-2.1,1.8-4.8,4.3-4.9,6.5c-0.2,3.7,6.1,9.1,10,9.2
                    c3.4,0.1,7.4-0.1,10.1-1.8c10.8-6.5,21.8-12.9,31.6-20.7c14.6-11.6,28.2-24.4,42.3-36.6c2.9-2.5,6-4.8,9.2-6.9
                    c12.7-8.1,28.9,0.4,29.2,15.5c0.2,7.8-0.3,15.7-0.5,23.5c0,0.9,0.3,1.9,0.4,2.8C261.8,316.7,262.2,316.9,262.6,317.1z M123.1,281.9
                    c0.5-0.2,1-0.3,1.3-0.6c13-14.1,23.9-29.4,29.3-48c1.2-4.2,0.9-8.9,1.3-13.6C137.8,221.7,123,263.3,123.1,281.9z">
                    </path>
                    <polygon class="st0" points="476.8,234.2 401,260.2 358.7,188.4 427.2,11.8 545.3,57.5 ">
                    </polygon>
                  </svg>

              </td>
              <td class="align-middle">
                {{ selectedRow.opportunity.updated_date.slice(0,10) | custom-date('MMMM d, yyyy') }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-3 validated reference_number_txt">
            <BaseInputForm
              type="text"
              label="New reference number"
              placeholder="Ex. CGTTUS00532"
              v-model="newReferenceNumber"
              @blur="$v.newReferenceNumber.$touch()"
              :validator="$v.newReferenceNumber"
              :disabled="isDuplicating || (selectedRow && this.selectedRow.meta.type === 'draft')" />
            <template v-if="$v.newReferenceNumber.$error">
              <div class="invalid-feedback" v-if="!$v.newReferenceNumber.required">
                <font-awesome-icon
                  :icon="['fas', 'exclamation-triangle']"
                  class="mr-1" /> Reference number is required.</div>
              <div
                class="invalid-feedback"
                v-if="!$v.newReferenceNumber.validateReferenceNumber">
                This reference number already exist.
              </div>
            </template>
          </div>
        </div>

        <div class="d-flex align-items-center mt-3">
          <button
            class="btn btn-wide btn-info ml-1 font-weight-bold"
            @click="duplicateOpportunity"
            :disabled="isDuplicating || isDone">
            <span v-if="!isDuplicating || isDone">Create</span>
            <span v-if="isDuplicating">
              <font-awesome-icon class="text-white" :icon="['fas', 'spinner']" spin />
            </span>
          </button>
          <p
            class="text-muted ml-3 mt-3"
            v-if="isDone && newVersionHash">
            The new version was generated in the following
            <router-link
              class="text-info font-weight-bold"
              :to="{ name: 'opportunity-edit', params: { privateId: newVersionHash }}">link</router-link>
          </p>
        </div>
      </div>

      <div class="text-center mb-4" v-if="currentModal === 'delete'">
        <font-awesome-icon class="text-warning" :icon="['fas', 'trash-alt']" size="4x" />
        <h1 class="text-info text-center my-4">Delete opportunity</h1>
        <p class="lead mb-5">Hi! Do you want to permanently delete this opportunity?</p>
        <button
          class="btn btn-wide btn-light btn--cancel mr-1 font-weight-bold"
          :disabled="isDeleting"
          @click="onCloseModal">No, thanks</button>
        <button
          class="btn btn-wide btn-info ml-1 font-weight-bold"
          @click="deleteOpportunity()"
          :disabled="isDeleting">
          <span v-if="!isDeleting">Yes, please delete it</span>
          <span v-if="isDeleting">
            <font-awesome-icon class="text-white" :icon="['fas', 'spinner']" spin />
          </span>
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import config from '@/config'

import Modal from '@/components/_shared/Modal.vue'
import ModalMixin from '@/mixins/modal'

import { required } from 'vuelidate/lib/validators'
import { validateReferenceNumber } from '@/validators'

import OpportunityListRow from '@/components/opportunity-list/OpportunityListRow.vue'
import OpportunityListNotFound from '@/components/opportunity-list/OpportunityListNotFound.vue'
import {OPPORTUNITY__STAGES} from "@/constants";

export default {
  name: 'OpportunityListTable',
  mixins: [ ModalMixin ],
  components: {
    OpportunityListRow,
    OpportunityListNotFound,
    Modal
  },
  data () {
    return {
      isDuplicating: false,
      isDone: false,
      selectedRow: null,
      newReferenceNumber: '',
      isSizeExtraLarge: false,
      currentModal: '',
      isDeleting: false,
      newVersionHash: ''
    }
  },
  beforeMount () {
    this.isDone = false
    this.newVersionHash = ''
  },
  validations () {
    if (this.selectedRow && this.selectedRow.meta.type === 'quoted') {
      return {
        newReferenceNumber: {
          required,
          newReferenceNumber: validateReferenceNumber
        }
      }
    }
    return { newReferenceNumber: {} }
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    isSearching: {
      type: Boolean,
      required: true
    },
    searchParams: {
      type: Object,
      required: false
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDuplicate: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    onSelect: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    open (privateId) {
      this.$router.push({ name: 'opportunity-edit', params: { privateId } })
    },
    onDuplicate (opportunity, meta) {
      this.isSizeExtraLarge = true
      this.currentModal = 'duplicate'
      this.selectedRow = { opportunity, meta }
      this.$v.$reset()
      this.onShowModal()
    },
    onDelete (opportunity, meta) {
      this.isSizeExtraLarge = false
      this.currentModal = 'delete'
      this.selectedRow = { opportunity, meta }
      this.onShowModal()
    },
    duplicateOpportunity () {
      this.$v.$touch()
      // submit form only when all fields are valid
      if (!this.$v.$invalid) {
        let type = 24
        if (this.selectedRow.meta.type === 'draft') {
          type = 24
        } else if (this.selectedRow.meta.type === 'quote') {
          type = 5
        }
        const payload = {
          type: type,
          uuid: this.selectedRow.opportunity.uuid,
          id_brand: this.selectedRow.opportunity.id_brand,
          reference_number: this.newReferenceNumber
        }
        this.isDuplicating = true
        this.isDone = false
        this.$store
          .dispatch('opportunity/duplicateOpportunity', payload)
          .then(response1 => {
            if (response1.data && !response1.data.status) {
              this.$notification.warning(response1.data.message, 8000)
              this.isDuplicating = false
              return false
            }

            const payload = {
              query: (this.searchParams && this.searchParams.query) ? this.searchParams.query : '',
              type: this.selectedRow.meta.typeId,
              limit: config.opportunityList.pagination.byPage,
              offset: 0
            }
            this.$store
              .dispatch('opportunity/listOpportunities', payload)
              .then(response2 => {
                this.isDuplicating = false
                this.isDone = true
                // this.selectedRow = null
                // this.newReferenceNumber = ''
                if (response1.data.data) {
                  this.newVersionHash = response1.data.data
                }
                this.$notification.success('Opportunity duplicated!')
                // this.highlightDuplicated(payload.reference_number, response2.data)
                this.$scrollTo('body', { duration: 600 })
              })
          })
          .catch(error => {
            console.log(error)
            this.isDuplicating = false
            this.$notification.warning('Opportunity duplication can not be duplicate because doesn\'t have REFERENCE NUMBER', 10000)
          })
      }
    },
    deleteOpportunity () {
      const payload = {
        uuid: this.selectedRow.opportunity.uuid
      }
      this.isDeleting = true
      this.$store
        .dispatch('opportunity/deleteOpportunity', payload)
        .then(response1 => {
          const payload = {
            query: (this.searchParams && this.searchParams.query) ? this.searchParams.query : '',
            type: this.selectedRow.meta.typeId,
            limit: config.opportunityList.pagination.byPage,
            offset: 0
          }
          this.$store
            .dispatch('opportunity/listOpportunities', payload)
            .then(response2 => {
              this.$notification.success(response1.data, 4000)
              this.$scrollTo('body', { duration: 600 })
              this.onCloseModal2()
            })
        })
        .catch(error => {
          console.log(error)
          this.isDeleting = false
          this.$notification.warning('Opportunity elimination can not be eliminate', 10000)
        })
      this.$emit('onDeleteOportunity')
    },
    highlightDuplicated (needle, haystack) {
      if (haystack && needle) {
        const duplicated = haystack.find(item => {
          return item.reference_number === needle
        })
        const field = `row_${duplicated.uuid}`
        this.$refs[field][0].$el.classList.toggle('highlighted')
        setTimeout(function () {
          this.$refs[field][0].$el.classList.toggle('highlighted')
        }.bind(this), 6000)
      }
    },
    onCloseModal2 () {
      this.isModalShow = false
      this.toggleClasses()
      this.currentModal = ''
      this.isDeleting = false
      this.selectedRow = null
      this.isDone = false
      this.newVersionHash = ''
    },
    styleStageSupplier (id) {
      // Sales_In_Progress = 4
      // Sales_Awaiting_Supplier = 20
      // Supplier_In_Progress = 21
      // Supplier_Done = 22
      // Sales_QUote_Sent = 23
      const STYLES = [
        { id: 4, backgroundColor: '#666666', color: '#FFFFFF' },
        { id: 20, backgroundColor: '#FFCC33', color: '#666666' },
        { id: 21, backgroundColor: '#666666', color: '#FFFFFF' },
        { id: 22, backgroundColor: '#0099CC', color: '#FFFFFF' },
        { id: 23, backgroundColor: '#2BC0A8', color: '#FFFFFF' },
        { id: OPPORTUNITY__STAGES.SALES_QUOTE_SENT_GO_AHEAD, backgroundColor: '#34981d', color: '#FFFFFF' },
      ]
      let found = STYLES.find(c => c.id === id)
      delete found.id
      return found || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.page-link {
  color: #cc0000 !important;
}
.page-item.disabled .page-link {
  color: #6c757d !important;
}
.page-item.active .page-link {
  background-color: #cc0000 !important;
  border-color: #cc0000 !important;
  color: #fff !important;
}
.w10 { width: 10%; }
.w20 { width: 20%; }
.w25 { width: 25%; }
.w100 { width: 100%; }
.w77 { width:77%; }
.wd150 { width: 150px !important; }
.highlighted {
  background: #ffc;
}
.isSearching {
  opacity: .6;
}
.minh {
  min-height: 340px;
}
.stage-supplier-label {
  font-weight: 500;
}
.badge-acronym--iv {
  background-color: #091F40;
}
.badge-acronym--cs {
  background-color: #0057A7;
}
.badge-acronym--t {
  background-color: #ED1941;
}
.badge-acronym--tc {
  background-color: #3182c5;
}
.badge-acronym--lg {
  background-color: #9a844a;
}
</style>
